export default {
  send (VueApp, data, callback) {
    // data.token = 'a518d247-e072-40f2-af4f-6f4d90e4f1e1'
    data.token = VueApp.$store.state.session.sessionToken
    VueApp.$sdk.post('/admin/prov/broadcast/sms', data, res => {
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/provider/sms.js